import React from "react";
import { HashLink } from "react-router-hash-link";

export default function CabeceraCostaAtlantica({ destino }) {
  return (
    <>
      <section className="promo-section mt-5 ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-10">
              <div className="section-heading mb-5">
                <span className="text-uppercase color-secondary sub-title">
                  Destino
                </span>
                <h2 className="mb-6">{destino}</h2>
                {/* Rearmas todo esto */}
                <p className="lead">
                  Un destino que ofrece una combinación perfecta de seguridad,
                  calidad y diversión. Juegos, fiestas, actividades recreativas
                  y muchas sorpresas garantizan una experiencia inolvidable.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-6 mb-lg-0">
              <HashLink className="nav-link" smooth to="#hoteleria">
                <div className="card single-promo-card single-promo-hover">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-home icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Hoteleria</h5>
                      <p className="text-muted mb-0">Upgrade Hotelería.</p>
                    </div>
                  </div>
                </div>
              </HashLink>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="card single-promo-card single-promo-hover mb-lg-0">
                <HashLink className="nav-link" smooth to="#diversion">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-face-smile icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Diversión</h5>
                      <p className="text-muted mb-0">Upgrade Diversión.</p>
                    </div>
                  </div>
                </HashLink>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <HashLink className="nav-link" smooth to="#transporte">
                <div className="card single-promo-card single-promo-hover mb-lg-0">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-car icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Transporte</h5>
                      <p className="text-muted mb-0">Upgrade Transporte.</p>
                    </div>
                  </div>
                </div>
              </HashLink>
            </div>
            <div className="col-lg-3 col-sm-6">
              <HashLink className="nav-link" smooth to="#asistenciamedica">
                <div className="card single-promo-card single-promo-hover mb-lg-0">
                  <div className="card-body">
                    <div className="pb-2">
                      <span className="ti-heart icon-md color-secondary"></span>
                    </div>
                    <div className="pt-2 pb-3">
                      <h5>Asistencia Médica</h5>
                      <p className="text-muted mb-0">
                        Cobertura completa al pasajero.
                      </p>
                    </div>
                  </div>
                </div>
              </HashLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
